import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var stepMessageMap = {
    '12': "Great progress — don't give up now.",
    '19': "Keep going! You're almost done with the test.",
};
export function EncouragementNotes(_a) {
    var id = _a.id;
    if (!id || !stepMessageMap[id])
        return null;
    return _jsx(_Fragment, { children: stepMessageMap[id] });
}
